import { useState, useEffect, useCallback } from 'react'
import { getWorkspace } from '../api/vestige.js'

export function useWorkspace(id) {
  const [workspace, setWorkspace] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetch = useCallback(async () => {
    if (!id) return
    setLoading(true)
    setError(null)
    try {
      const data = await getWorkspace(id)
      setWorkspace(data)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [id])

  useEffect(() => {
    fetch()
  }, [fetch])

  const update = useCallback((updater) => {
    setWorkspace((prev) => (prev ? updater(prev) : prev))
  }, [])

  return { workspace, loading, error, refresh: fetch, update }
}
